import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { getTemplate } from 'components/VertNotification';
import { VertIcon, VertTokens } from '@vertem-core/vertice-ds';

const VertAccordionGift = ({ children, ...props }) => {
  const { className, template, label, size, opened } = props;

  const iconOpen = props.iconOpen || <VertIcon
    isVertice
    iconFamily="VertIconUIRound"
    iconStyle="Regular"
    iconName="ArrowDown"
  />
  const iconClose = props.iconClose || <VertIcon
    isVertice
    iconFamily="VertIconUIRound"
    iconStyle="Regular"
    iconName="ArrowUp"
  />

  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const contentRef = useRef(null);

  const { sharedTemplate } = React.useContext(VertTokens);

  const finalTemplate = template || sharedTemplate;

  const openHandler = () => {
    setIsOpen(!isOpen);
    setIsActive(!isActive);
  };

  React.useEffect(() => {
    if (opened) {
      setIsOpen(true);
      setIsActive(true);
    }
  }, [opened]);

  return (
    <div
      className={`${getTemplate(finalTemplate)} vert-accordion ${className} ${
        isActive ? 'active' : ''
      }`}
    >
      <div
        className={`accordion-header accordion-${size}`}
        type="button"
        onClick={openHandler}
      >
        <span className="accordion-label">{label}</span>
        {isOpen ? iconClose : iconOpen}
      </div>

      <div
        className={`accordion-content ${isOpen ? 'active' : ''}`}
        ref={contentRef}
        style={{
          height: isOpen ? contentRef.current.scrollHeight + 'px' : '0',
        }}
      >
        {children}
      </div>
    </div>
  );
};

VertAccordionGift.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['default', 'small', 'large']),
  template: PropTypes.oneOf(['default', 'marketplace']),
  iconOpen: PropTypes.node,
  iconClose: PropTypes.node,
};


export default VertAccordionGift;
